// Module
var code = `<form name="\$ctrl.form">
  <validator condition="\$ctrl.isAsEarnedAdvanceInterestValid() 
  && \$ctrl.isAsEarnedInterestPeriodValid()
  && \$ctrl.isInterestCalculationMethodValid()
  && \$ctrl.isAsEarnedPreterminationInterestCalculationValid()">

  </validator>

  <div class="form-section">
    <form-section form-title="'Payment & interests'">
      <form-section-field field-title="'Payment direction'">
        <select
          ng-model="\$ctrl.loanProduct.paymentDirection"
          ng-options="o.value as o.label for o in \$ctrl.paymentDirections"
          ng-required="true"></select>
      </form-section-field>
      <form-section-field field-title="'Payment interval options'">
        <multiselect items="\$ctrl.intervalTypes"
                     ng-model="\$ctrl.loanProduct.paymentIntervalOptions"
                     ng-change="\$ctrl.conditionalWeeksInYearReset()"
                     label-property="'name'"
                     value-property="'id'"
                     ng-required="true">
        </multiselect>
      </form-section-field>

      <form-section-field field-title="'Override and use constant number of weeks'"
                          ng-if="\$ctrl.hasWeeklyAmortizationOption()">
        <select ng-model="\$ctrl.overrideWeeksInYear"
                ng-init="\$ctrl.overrideWeeksInYear = !!\$ctrl.loanProduct.weeksInYear"
                ng-change="\$ctrl.conditionalWeeksInYearReset()"
                boolean-options
                required>
        </select>
      </form-section-field>

      <form-section-field field-title="'Number of weeks'"
                          ng-if="\$ctrl.overrideWeeksInYear">
        <input type="number"
               ng-model="\$ctrl.loanProduct.weeksInYear"
               min="1"
               required />
      </form-section-field>

      <form-section-field field-title="'Calculate first payment date by default'">
        <select ng-model="\$ctrl.loanProduct.calculateDefaultFirstPaymentDate"
                boolean-options
                required>
        </select>
      </form-section-field>
      <form-section-field field-title="'Default amortization number'">
        <input type="number" min="1" step="1" ng-model="\$ctrl.loanProduct.defaultAmortizationNumber"/>
      </form-section-field>
      <form-section-field field-title="'Interest type'">
        <select
          ng-model="\$ctrl.loanProduct.interestType"
          ng-options="o.value as o.label for o in \$ctrl.interestTypes"
          ng-change="\$ctrl.interestTypeOnChanged(\$ctrl.loanProduct.interestType)"
          ng-required="true"></select>
      </form-section-field>
      <form-section-field field-title="'Min. Interest rate'">
        <glue-container append-percentage="true">
          <input
            type="number"
            ng-model="\$ctrl.loanProduct.minInterestRate"
            ng-required="true"
            min="0" max="100" step="0.00001">
        </glue-container>
      </form-section-field>
      <form-section-field field-title="'Max. Interest rate'">
        <glue-container append-percentage="true">
          <input
            type="number"
            ng-model="\$ctrl.loanProduct.maxInterestRate"
            ng-required="true"
            min="0"
            max="100"
            step="0.00001">
        </glue-container>
      </form-section-field>
      <form-section-field field-title="'Default Interest rate'">
        <glue-container append-percentage="true">
          <input
            type="number"
            ng-model="\$ctrl.loanProduct.defaultInterestRate"
            ng-required="true"
            ng-min="\$ctrl.loanProduct.minInterestRate"
            ng-max="\$ctrl.loanProduct.maxInterestRate"
            step="0.00001">
        </glue-container>
      </form-section-field>
      <form-section-field field-title="'Use interest rate board'">
        <select
          required
          ng-model="\$ctrl.loanProduct.useInterestRateBoard"
          boolean-options>
        </select>
      </form-section-field>
      <form-section-field field-title="'Past due interest rate'">
        <div>
          <charge charge="\$ctrl.loanProduct.pastDueInterestCharge"
                types="\$ctrl.pastDueInterestChargeTypes"
                disable-rate="\$ctrl.loanProduct.defaultPastDueToInterestRate"
                interest-type="\$ctrl.loanProduct.interestType">
          </charge>
          <div class="alert" ng-if="\$ctrl.loanProduct.interestType ==='ADD_ON_RATE' && \$ctrl.loanProduct.amortizationType === 'DIMINISHING_EQUAL_AMORTIZATION'">
            Rate is based on monthly add-on
          </div>
        </div>
      </form-section-field>
      <form-section-field field-title="'Default past due interest to interest rate'" fit-content="true">
        <select
          required
          ng-model="\$ctrl.loanProduct.defaultPastDueToInterestRate"
          ng-change="\$ctrl.resetPastDueInterest()"
          boolean-options>
        </select>
        <help title="When 'Yes', Past Due Interest will be taken from the Loan Interest Rate" ></help>
      </form-section-field>
      <form-section-field field-title="'Collection type'">
        <select
          required
          ng-model="\$ctrl.loanProduct.pastDueInterestCollectionType"
          ng-options="collectionType | prettyEnum for collectionType in \$ctrl.pdiChargeCollectionTypes">
        </select>
      </form-section-field>
      <form-section-field field-title="'Past due interest grace period'">
        <glue-container append="'days'">
          <input type="number"
                 ng-model="\$ctrl.loanProduct.pastDueInterestGracePeriod"
                 ng-required="true"
                 min="0">
        </glue-container>
      </form-section-field>
      <form-section-field field-title="'Apply past due interest on maturity'" fit-content="true">
        <select
          required
          ng-model="\$ctrl.loanProduct.pastDueInterestApplyOnMaturity"
          boolean-options>
        </select>
        <help title="When 'Yes' is selected it will be applied to all amortizations except the last one"></help>
      </form-section-field>
      <form-section-field field-title="'Past due maturity interest rate'">
        <div>
          <charge charge="\$ctrl.loanProduct.pastDueMaturityInterestCharge"
                  types="\$ctrl.pastDueInterestChargeTypes"
                  disable-rate="\$ctrl.loanProduct.defaultPastDueMaturityToInterestRate"
                  interest-type="\$ctrl.loanProduct.interestType">
          </charge>
          <div class="alert" ng-if="\$ctrl.loanProduct.interestType ==='ADD_ON_RATE' && \$ctrl.loanProduct.amortizationType === 'DIMINISHING_EQUAL_AMORTIZATION'">
            Rate is based on monthly add-on
          </div>
        </div>
      </form-section-field>
      <form-section-field field-title="'Default past due maturity interest to interest rate'" fit-content="true">
        <select
          required
          ng-model="\$ctrl.loanProduct.defaultPastDueMaturityToInterestRate"
          ng-change="\$ctrl.resetPastDueMaturityInterest()"
          boolean-options>
        </select>
        <help title="When 'Yes', Past Due Maturity Interest will be taken from the Loan Interest Rate"></help>
      </form-section-field>
      <form-section-field field-title="'Apply past due maturity interest rate on'">
        <select ng-model="\$ctrl.loanProduct.pastDueMaturityInterestApplyOn"
                ng-options="hook | prettyEnum for hook in \$ctrl.amortizationHooks"
                ng-change="\$ctrl.pastDueMaturityInterestApplyOnChanged(\$ctrl.loanProduct.pastDueMaturityInterestApplyOn)"
                ng-required="true">
        </select>
      </form-section-field>
      <form-section-field field-title="'Apply collection on'" ng-if="\$ctrl.loanProduct.pastDueMaturityInterestApplyOn === 'LAST_AMORTIZATION'">
        <select ng-model="\$ctrl.loanProduct.pastDueInterestMaturityCollectionSchedule"
                ng-options="collectionSchedule | prettyEnum for collectionSchedule in \$ctrl.feeCollectionScheduleOptions"
                ng-required="true">
        </select>
      </form-section-field>
      <form-section-field field-title="'Calculate and apply penalty on:'">
        <select ng-model="\$ctrl.loanProduct.penaltyApplicationType"
                ng-options="hook | prettyEnum for hook in \$ctrl.penaltyApplicationTypes"
                ng-required="true">
        </select>
      </form-section-field>
      <form-section-field field-title="'Penalty grace period'">
        <glue-container append="'days'">
          <input type="number"
                 ng-model="\$ctrl.loanProduct.penaltyGracePeriod"
                 ng-required="true"
                 min="0"
                 ng-max="\$ctrl.loanMaxPenaltyGracePeriod">
        </glue-container>
      </form-section-field>
      <form-section-field field-title="'Recalculate penalty'">
        <select boolean-options
                ng-model="\$ctrl.loanProduct.recalculatePenalty"
                ng-change="\$ctrl.refreshRecalculatePenaltyOn()"
                ng-required="true">
        </select>
      </form-section-field>
      <form-section-field field-title="'Apply to'"
                          ng-if="\$ctrl.loanProduct.recalculatePenalty">
        <multiselect items="\$ctrl.recalculatePenaltyOptions"
                     ng-model="\$ctrl.loanProduct.recalculatePenaltyOn"
                     ng-required="true">
        </multiselect>
      </form-section-field>
      <form-section-field field-title="'Due & demandable (recalculate total interest as earned) if no payment after '">
        <glue-container append="'days'">
          <input type="number"
                 ng-model="\$ctrl.loanProduct.dueAndDemandableThreshold"
                 ng-required="true"
                 min="0">
        </glue-container>
        <help title="This feature only triggers when this threshold is set to a number greater than 0."></help>
      </form-section-field>
      <form-section-field field-title="'Pretermination interest as earned'"
                          ng-if="['COMPOUND', 'SIMPLE'].includes(\$ctrl.loanProduct.interestCalculationMethod)" fit-content="true">
        <select
          ng-class="{'nx-invalid': !\$ctrl.isAsEarnedPreterminationInterestCalculationValid()}"
          ng-disabled="\$ctrl.loanProduct.interestType === 'ADD_ON_RATE' && \$ctrl.isAsEarnedPreterminationInterestCalculationValid()"
          ng-model="\$ctrl.loanProduct.asEarnedPreterminationInterestCalculation"
          ng-change="\$ctrl.preterminationAsEarnedOnChanged()"
          boolean-options
          ng-required="true"></select>
        <help ng-if="\$ctrl.loanProduct.interestType === 'ADD_ON_RATE'"
          title="Currently not supported for add-on interest type">
        </help>
      </form-section-field>
      <form-section-field field-title="'Collect full interest on overdue'"
                          ng-if="\$ctrl.loanProduct.asEarnedPreterminationInterestCalculation" fit-content="true">
        <select
          ng-if="\$ctrl.loanProduct.asEarnedPreterminationInterestCalculation"
          ng-model="\$ctrl.loanProduct.pretermCollectFullInterest"
          boolean-options
          ng-required="true"></select>
        <help title="During pretermination, collect all the excess unpaid amortization unearned interests">
        </help>
      </form-section-field>
      <form-section-field field-title="'Interest calculation method'" fit-content="true">
        <select
          ng-class="{'nx-invalid': !\$ctrl.isInterestCalculationMethodValid()}"
          ng-disabled="\$ctrl.loanProduct.interestType === 'ADD_ON_RATE' && \$ctrl.isInterestCalculationMethodValid()"
          ng-model="\$ctrl.loanProduct.interestCalculationMethod"
          ng-options="o.value as o.label for o in \$ctrl.interestCalculationMethods"
          ng-change="\$ctrl.setDefaultInterestCalculationMethod()"
          ng-required="true">
        </select>
        <help ng-if="\$ctrl.loanProduct.interestType === 'ADD_ON_RATE'"
          title="Add-on interest type is supported on simple interest calculation method only.">
        </help>
      </form-section-field>
      <form-section-field field-title="'With UID Ledger'">
        <select boolean-options
                ng-model="\$ctrl.loanProduct.withUIDLedger"
                ng-required="true">
        </select>
      </form-section-field>
      <form-section-field field-title="'For advance payments, recalculate and collect interest as earned'"
                          ng-if="\$ctrl.loanProduct.interestCalculationMethod === 'COMPOUND'">
        <select
          ng-class="{'nx-invalid': !\$ctrl.isAsEarnedAdvanceInterestValid()}"
          boolean-options
          ng-model="\$ctrl.loanProduct.asEarnedInterestCalculation"
          required></select>
        <help
            ng-if="!\$ctrl.isAsEarnedAdvanceInterestValid()"
            title="As earned and advance interest cannot be enabled at the same time"
        >
        </help>
      </form-section-field>
      <form-section-field field-title="'As earned accrual period'"
                          ng-if="\$ctrl.loanProduct.asEarnedInterestCalculation">
        <select
          ng-class="{'nx-invalid': !\$ctrl.isAsEarnedInterestPeriodValid()}"
          required
          ng-model="\$ctrl.loanProduct.asEarnedInterestAccrualPeriod"
          ng-options="period.value as period.label for period in \$ctrl.asEarnedInterestAccrualPeriodOptions">
        </select>
        <help
            ng-if="\$ctrl.loanProduct.asEarnedInterestAccrualPeriod === 'MONTH_END'
              && \$ctrl.loanProduct.asEarnedPreterminationInterestCalculation"
            title="As earned pre-termination interest calculation must be set to false">
        </help>
        <help
            ng-if="\$ctrl.loanProduct.asEarnedInterestAccrualPeriod === 'MONTH_END'
              && !\$ctrl.loanProduct.asEarnedPreterminationInterestCalculation
              && \$ctrl.hasInvalidSelectedPaymentIntervals()"
            title="Payment interval can only have base interval of MONTHLY with interval count of 1 or DAILY with interval count of 30 or interval type of SET DAYS OF MONTH with interval count of 30">
        </help>
      </form-section-field>
      <form-section-field field-title="'Allow overpayment'">
        <select
          boolean-options
          ng-model="\$ctrl.loanProduct.allowOverpayment"
          required>
        </select>
      </form-section-field>
      <form-section-field field-title="'Overpayment strategy'"
                          ng-if="\$ctrl.loanProduct.allowOverpayment && \$ctrl.loanProduct.withContractualSavings">
        <select ng-model="\$ctrl.loanProduct.overPaymentStrategy"
                ng-options="a.value as a.label for a in \$ctrl.overPaymentStrategy"
                required></select>
      </form-section-field>
      <form-section-field field-title="'Overpayment GL account'"
                          ng-if="\$ctrl.loanProduct.allowOverpayment && ( \$ctrl.loanProduct.overPaymentStrategy === 'CREDIT_TO_GL' || !\$ctrl.loanProduct.withContractualSavings )">

        <field
          options="\$ctrl.glAccounts"
          field="fullCode"
          ng-model="\$ctrl.loanProduct.overpaymentGLCode"
          transcluded-model="\$ctrl.tmpAccountFullCode">
          <account-select options="\$ctrl.glAccounts"
                          ng-model="\$ctrl.tmpAccountFullCode"
                          value-field="'id'"
                          required>
          </account-select>
        </field>
      </form-section-field>

    </form-section>

    <form-section form-title="'Amortization'">

      <!-- amortization types based on the interest calculation methods -->
      <form-section-field field-title="'Amortization type'"
                          ng-if="\$ctrl.loanProduct.interestType === 'ANNUAL_RATE' && \$ctrl.loanProduct.interestCalculationMethod == 'SIMPLE'">
        <select ng-model="\$ctrl.loanProduct.amortizationType"
                ng-options="o.value as o.label for o in \$ctrl.simpleAmortizationTypes"
                ng-required="true"></select>
      </form-section-field>

      <form-section-field field-title="'Amortization type'"
            ng-if="\$ctrl.loanProduct.interestType === 'ADD_ON_RATE' && \$ctrl.loanProduct.interestCalculationMethod == 'SIMPLE'">
        <select ng-model="\$ctrl.loanProduct.amortizationType"
                ng-options="o.value as o.label for o in \$ctrl.addOnRateSimpleAmortizationTypes"
                ng-required="true"></select>
      </form-section-field>

      <form-section-field field-title="'Amortization type'"
                          ng-if="\$ctrl.loanProduct.interestCalculationMethod == 'COMPOUND'">
        <select ng-model="\$ctrl.loanProduct.amortizationType"
                ng-options="o.value as o.label for o in \$ctrl.compoundAmortizationTypes"
                ng-required="true"></select>
      </form-section-field>

      <form-section-field field-title="'Apply principal every: (0 for no default value)'"
                          ng-if="\$ctrl.balloonCyclicAmortizationTypes.includes(\$ctrl.loanProduct.amortizationType)">
        <glue-container append="'amortizations'">
          <input type="number"
                 ng-model="\$ctrl.loanProduct.defaultInterestCalculationParameter"
                 ng-required="true"
                 step="1"
                 min="0"
                 max="365"
          >
        </glue-container>
      </form-section-field>

      <form-section-field field-title="'Spread percentage'"
                          ng-if="['BALLOON_SPREAD'].includes(\$ctrl.loanProduct.amortizationType)"
                          title="The percentage amount that will be distributed evenly between all but the last amortization">
        <glue-container append-percentage="true">
          <input type="number"
                 ng-model="\$ctrl.loanProduct.defaultInterestCalculationParameter"
                 ng-required="true"
                 step="1"
                 min="1"
                 max="100"
          >
        </glue-container>
      </form-section-field>

      <form-section-field field-title="'Amortization divisor'">
        <glue-container append="'days'">
          <select
            ng-model="\$ctrl.loanProduct.productDefinition.daysInYear"
            ng-options="o.value as o.label for o in \$ctrl.amortizationDivisors"
            ng-required="true">
          </select>
        </glue-container>
      </form-section-field>

      <form-section-field field-title="'Min. First payment validation'">
        <select ng-model="\$ctrl.loanProduct.validateMinFirstPaymentDate"
                boolean-options
                required>
        </select>
      </form-section-field>

      <form-section-field field-title="'First payment date max. postponement'">
        <glue-container append="'days'">
          <input type="number"
                 ng-model="\$ctrl.loanProduct.maxFirstPaymentPostponement"
                 ng-required="true"
                 min="0" max="365">
        </glue-container>
      </form-section-field>
    </form-section>

    <form-section form-title="'Advance interest'" ng-if="\$ctrl.loanProduct.interestCalculationMethod != 'ADVANCE'">
      <form-section-field field-title="'Collect advance interest'">
        <select
            ng-class="{'nx-invalid': !\$ctrl.isAsEarnedAdvanceInterestValid()}"
            ng-model="\$ctrl.loanProduct.collectAdvanceInterest"
            boolean-options
            required>
        </select>
        <help
            ng-if="!\$ctrl.isAsEarnedAdvanceInterestValid()"
            title="As earned and advance interest cannot be enabled at the same time"
        >
        </help>
      </form-section-field>

      <form-section-field field-title="'Maximum advance interest no'" ng-if="\$ctrl.loanProduct.collectAdvanceInterest">
        <glue-container append="'amortizations'">
          <input type="number"
                 ng-model="\$ctrl.loanProduct.advanceInterestMaxNo"
                 required
                 min="0">
        </glue-container>
      </form-section-field>

      <form-section-field field-title="'Default advance interest no'" ng-if="\$ctrl.loanProduct.collectAdvanceInterest">
        <glue-container append="'amortizations'">
          <input type="number"
                 ng-model="\$ctrl.loanProduct.advanceInterestDefaultNo"
                 required
                 min="0"
                 ng-max="\$ctrl.loanProduct.advanceInterestMaxNo || 0">
        </glue-container>
      </form-section-field>

      <form-section-field field-title="'Default advance interest application'" ng-if="\$ctrl.loanProduct.collectAdvanceInterest">
        <select
            ng-model="\$ctrl.loanProduct.advanceInterestDefaultApplication"
            ng-options="a.value as a.label for a in \$ctrl.advanceInterestApplicationTypes"
            required>
        </select>
      </form-section-field>
    </form-section>

  </div>

  <div class="form-section">
    <div class="form-section">
      <h2 class="section-header">Amortization Rounding</h2>
      <table class="table">
        <thead>
        <th class="first-column">Part</th>
        <th>Scale</th>
        <th>Mode</th>
        </thead>
        <tbody>
        <tr>
          <td class="first-column">Principal{{ \$ctrl.isOverridden('PRINCIPAL') ? ' (*)' : '' }}:</td>
          <td><select ng-model="\$ctrl.loanProduct.principalRoundingScale"
                      ng-options="o.value as o.label for o in \$ctrl.roundingScales"
                      required>
          </select></td>
          <td><select ng-model="\$ctrl.loanProduct.principalRoundingMode"
                      ng-options="o.value as o.label for o in \$ctrl.roundingModes"
                      required>
          </select></td>
        </tr>
        <tr>
          <!-- Interest rounding -->
          <td class="first-column">Interest{{ \$ctrl.isOverridden('INTEREST') ? ' (*)' : '' }}:</td>
          <td><select ng-model="\$ctrl.loanProduct.interestRoundingScale"
                      ng-options="o.value as o.label for o in \$ctrl.roundingScales"
                      required>
          </select></td>
          <td><select ng-model="\$ctrl.loanProduct.interestRoundingMode"
                      ng-options="o.value as o.label for o in \$ctrl.roundingModes"
                      required>
          </select></td>
        </tr>
        <tr>
          <td class="first-column">CBU:</td>
          <td><select ng-model="\$ctrl.loanProduct.cbuRoundingScale"
                      ng-options="o.value as o.label for o in \$ctrl.roundingScales"
                      required>
          </select></td>
          <td><select ng-model="\$ctrl.loanProduct.cbuRoundingMode"
                      ng-options="o.value as o.label for o in \$ctrl.roundingModes"
                      required>
          </select></td>
        </tr>
        <tr>
          <td class="first-column">PF:</td>
          <td><select ng-model="\$ctrl.loanProduct.pfRoundingScale"
                      ng-options="o.value as o.label for o in \$ctrl.roundingScales"
                      required>
          </select></td>
          <td><select ng-model="\$ctrl.loanProduct.pfRoundingMode"
                      ng-options="o.value as o.label for o in \$ctrl.roundingModes"
                      required>
          </select></td>
        </tr>
        <tr>
          <td class="first-column">TP:</td>
          <td><select ng-model="\$ctrl.loanProduct.tpRoundingScale"
                      ng-options="o.value as o.label for o in \$ctrl.roundingScales"
                      required>
          </select></td>
          <td><select ng-model="\$ctrl.loanProduct.tpRoundingMode"
                      ng-options="o.value as o.label for o in \$ctrl.roundingModes"
                      required>
          </select></td>
        </tr>
        <tr>
          <!-- Amortization rounding -->
          <td class="first-column">Total amortization:</td>
          <td><select ng-model="\$ctrl.loanProduct.totalAmortizationRoundingScale"
                      ng-options="o.value as o.label for o in \$ctrl.roundingScales"
                      required>
          </select></td>
          <td><select ng-model="\$ctrl.loanProduct.totalAmortizationRoundingMode"
                      ng-options="o.value as o.label for o in \$ctrl.roundingModes"
                      required>
          </select></td>
        </tr>
        <tr ng-if="\$ctrl.shouldShowRoundingDifferenceTarget()">
          <td colspan="3">
            <div class="alert">When choosing an amortization type with equal amortization
              or setting total amortization rounding different than centavo,
              you have to specify where the rounding correction will be applied.</div>
          </td>
        </tr>
        <tr ng-if="\$ctrl.shouldShowRoundingDifferenceTarget()">
          <!-- Rounding difference target -->
          <td class="first-column">(*) Apply total amortization rounding difference to:</td>
          <td colspan="2">
            <select ng-model="\$ctrl.loanProduct.roundingDifferenceTarget"
                    ng-options="o.value as o.label for o in \$ctrl.roundingDifferenceTargets"
                    required
                    class="full-width">
            </select></td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="form-section">
      <h2 class="section-header">Fee Rounding</h2>
      <table class="table">
        <thead>
        <th class="first-column">Part</th>
        <th>Scale</th>
        <th>Mode</th>
        </thead>
        <tbody>
        <tr>
          <td class="first-column">Doc Stamp:</td>
          <td><select ng-model="\$ctrl.loanProduct.docStampRoundingScale"
                      ng-options="o.value as o.label for o in \$ctrl.roundingScales"
                      required>
          </select></td>
          <td><select ng-model="\$ctrl.loanProduct.docStampRoundingMode"
                      ng-options="o.value as o.label for o in \$ctrl.roundingModes"
                      required>
          </select></td>
        </tr>
        <tr>
          <td class="first-column">Notarial Fee:</td>
          <td><select ng-model="\$ctrl.loanProduct.notarialFeeRoundingScale"
                      ng-options="o.value as o.label for o in \$ctrl.roundingScales"
                      required>
          </select></td>
          <td><select ng-model="\$ctrl.loanProduct.notarialFeeRoundingMode"
                      ng-options="o.value as o.label for o in \$ctrl.roundingModes"
                      required>
          </select></td>
        </tr>
        <tr>
          <td class="first-column">Application Fee:</td>
          <td><select ng-model="\$ctrl.loanProduct.applicationFeeRoundingScale"
                      ng-options="o.value as o.label for o in \$ctrl.roundingScales"
                      required>
          </select></td>
          <td><select ng-model="\$ctrl.loanProduct.applicationFeeRoundingMode"
                      ng-options="o.value as o.label for o in \$ctrl.roundingModes"
                      required>
          </select></td>
        </tr>
        <tr>
          <td class="first-column">Credit Investigation Fee:</td>
          <td><select ng-model="\$ctrl.loanProduct.creditInvestigationFeeRoundingScale"
                      ng-options="o.value as o.label for o in \$ctrl.roundingScales"
                      required>
          </select></td>
          <td><select ng-model="\$ctrl.loanProduct.creditInvestigationFeeRoundingMode"
                      ng-options="o.value as o.label for o in \$ctrl.roundingModes"
                      required>
          </select></td>
        </tr>
        <tr>
          <td class="first-column">Extra Bank Fee:</td>
          <td><select ng-model="\$ctrl.loanProduct.extraBankFeeRoundingScale"
                      ng-options="o.value as o.label for o in \$ctrl.roundingScales"
                      required>
          </select></td>
          <td><select ng-model="\$ctrl.loanProduct.extraBankFeeRoundingMode"
                      ng-options="o.value as o.label for o in \$ctrl.roundingModes"
                      required>
          </select></td>
        </tr>
        <tr>
          <td class="first-column">Membership Fee:</td>
          <td><select ng-model="\$ctrl.loanProduct.membershipFeeRoundingScale"
                      ng-options="o.value as o.label for o in \$ctrl.roundingScales"
                      required>
          </select></td>
          <td><select ng-model="\$ctrl.loanProduct.membershipFeeRoundingMode"
                      ng-options="o.value as o.label for o in \$ctrl.roundingModes"
                      required>
          </select></td>
        </tr>
        <tr>
          <td class="first-column">Id Fee:</td>
          <td><select ng-model="\$ctrl.loanProduct.idFeeRoundingScale"
                      ng-options="o.value as o.label for o in \$ctrl.roundingScales"
                      required>
          </select></td>
          <td><select ng-model="\$ctrl.loanProduct.idFeeRoundingMode"
                      ng-options="o.value as o.label for o in \$ctrl.roundingModes"
                      required>
          </select></td>
        </tr>
        <tr>
          <td class="first-column">Service Charge:</td>
          <td><select ng-model="\$ctrl.loanProduct.serviceChargeRoundingScale"
                      ng-options="o.value as o.label for o in \$ctrl.roundingScales"
                      required>
          </select></td>
          <td><select ng-model="\$ctrl.loanProduct.serviceChargeRoundingMode"
                      ng-options="o.value as o.label for o in \$ctrl.roundingModes"
                      required>
          </select></td>
        </tr>
        <tr>
          <td class="first-column">Insurance Fee:</td>
          <td><select ng-model="\$ctrl.loanProduct.insuranceFeeRoundingScale"
                      ng-options="o.value as o.label for o in \$ctrl.roundingScales"
                      required>
          </select></td>
          <td><select ng-model="\$ctrl.loanProduct.insuranceFeeRoundingMode"
                      ng-options="o.value as o.label for o in \$ctrl.roundingModes"
                      required>
          </select></td>
        </tr>
        <tr>
          <td class="first-column">Insurance Service Fee:</td>
          <td><select ng-model="\$ctrl.loanProduct.insuranceServiceFeeRoundingScale"
                      ng-options="o.value as o.label for o in \$ctrl.roundingScales"
                      required>
          </select></td>
          <td><select ng-model="\$ctrl.loanProduct.insuranceServiceFeeRoundingMode"
                      ng-options="o.value as o.label for o in \$ctrl.roundingModes"
                      required>
          </select></td>
        </tr>
        <tr>
          <td class="first-column">Insurance Processing Fee:</td>
          <td><select ng-model="\$ctrl.loanProduct.insuranceProcessingFeeRoundingScale"
                      ng-options="o.value as o.label for o in \$ctrl.roundingScales"
                      required>
          </select></td>
          <td><select ng-model="\$ctrl.loanProduct.insuranceProcessingFeeRoundingMode"
                      ng-options="o.value as o.label for o in \$ctrl.roundingModes"
                      required>
          </select></td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="form-section">

    <form-section form-title="'Interest Accrual'">
      <form-section-field field-title="'Allow accrual'">
        <select ng-model="\$ctrl.loanProduct.allowAccrual"
                boolean-options
                required>
        </select>
      </form-section-field>

      <form-section-field field-title="'Allow accrual for past due performing loans'"
                          ng-if="\$ctrl.loanProduct.allowAccrual">
        <select ng-model="\$ctrl.loanProduct.allowAccrualOnPastDuePerforming"
                ng-disabled="\$ctrl.isAccrualAllowed()"
                boolean-options
                required>
        </select>
      </form-section-field>

      <form-section-field field-title="'Accrual period'"
                          ng-if="\$ctrl.loanProduct.allowAccrual">
        <select ng-model="\$ctrl.loanProduct.accrualPeriod"
                required
                ng-options="o.value as o.label for o in \$ctrl.accrualPeriod"
                ng-disabled="\$ctrl.isAccrualAllowed()"></select>
      </form-section-field>

    </form-section>

    <form-section form-title="'Holidays'">
      <form-section-field field-title="'Honor holidays?'">
        <select ng-model="\$ctrl.loanProduct.honorHolidays"
                boolean-options
                required></select>
      </form-section-field>
      <form-section-field field-title="'When amortization due date falls on a holiday (holiday and loan holiday)'"
                          ng-if="\$ctrl.loanProduct.honorHolidays">
        <select ng-model="\$ctrl.loanProduct.holidayAmortizationAdjustment"
                ng-options="a.value as a.label for a in \$ctrl.amortizationAdjustmentStrategy"
                ng-change="\$ctrl.checkAmortizationAdjustment()"
                required></select>
      </form-section-field>
      <form-section-field field-title="'Move amortization if there are two or more on the same day'"
                          ng-if="\$ctrl.loanProduct.honorHolidays && \$ctrl.loanProduct.holidayAmortizationAdjustment === 'NEXT_WORKING_DAY' && \$ctrl.loanProduct.termCalculationMethod === 'EXACT_DAYS'">
        <select ng-model="\$ctrl.loanProduct.moveDuplicatedAmortizationHoliday"
                boolean-options
                required></select>
      </form-section-field>
      <form-section-field field-title="'When amortization due date falls on a non-working Saturday'"
                          ng-if="\$ctrl.loanProduct.honorHolidays">
        <select ng-model="\$ctrl.loanProduct.saturdayAmortizationAdjustment"
                ng-options="a.value as a.label for a in \$ctrl.amortizationAdjustmentStrategy"
                ng-change="\$ctrl.checkAmortizationAdjustment()"
                required></select>
      </form-section-field>
      <form-section-field field-title="'Move amortization if there are two or more on the same day'"
                          ng-if="\$ctrl.loanProduct.honorHolidays && \$ctrl.loanProduct.saturdayAmortizationAdjustment === 'NEXT_WORKING_DAY' && \$ctrl.loanProduct.termCalculationMethod === 'EXACT_DAYS'">
        <select ng-model="\$ctrl.loanProduct.moveDuplicatedAmortizationSaturday"
                boolean-options
                required></select>
      </form-section-field>
      <form-section-field field-title="'When amortization due date falls on a non-working Sunday'"
                          ng-if="\$ctrl.loanProduct.honorHolidays">
        <select ng-model="\$ctrl.loanProduct.sundayAmortizationAdjustment"
                ng-options="a.value as a.label for a in \$ctrl.amortizationAdjustmentStrategy"
                ng-change="\$ctrl.checkAmortizationAdjustment()"
                required></select>
      </form-section-field>
      <form-section-field field-title="'Move amortizations if there are two or more on the same day'"
                          ng-if="\$ctrl.loanProduct.honorHolidays && \$ctrl.loanProduct.sundayAmortizationAdjustment === 'NEXT_WORKING_DAY' && \$ctrl.loanProduct.termCalculationMethod === 'EXACT_DAYS'">
        <select ng-model="\$ctrl.loanProduct.moveDuplicatedAmortizationSunday"
                boolean-options
                required></select>
      </form-section-field>
      <form-section-field field-title="'When LAST AMORTIZATION due date falls on a non-working Saturday/Sunday/Holiday'"
                          ng-if="\$ctrl.loanProduct.honorHolidays">
        <select ng-model="\$ctrl.loanProduct.lastPaymentDateAdjustment"
                ng-options="a.value as a.label for a in \$ctrl.amortizationAdjustmentStrategy"
                required></select>
      </form-section-field>
    </form-section>

    <form-section form-title="'Due/overdue payment hierarchy'">
      <ul class="dragula-loans-container" dragula='"dueHierarchy"' dragula-model="\$ctrl.loanProduct.duePaymentHierarchy">
        <li ng-repeat="part in \$ctrl.loanProduct.duePaymentHierarchy" class="dragula-loans">
          {{part}}
        </li>
      </ul>
    </form-section>

    <form-section form-title="'Advance payment'">
      <form-section-field field-title="'When advance payment is made'">
        <select ng-model="\$ctrl.loanProduct.advancePaymentStrategy"
                ng-options="a.value as a.label for a in \$ctrl.advancePaymentStrategy"
                required></select>
      </form-section-field>
      <ul class="dragula-loans-container"
          dragula='"advanceHierarchy"'
          dragula-model="\$ctrl.loanProduct.advancePaymentHierarchy"
          ng-if="\$ctrl.loanProduct.advancePaymentStrategy === 'PAYMENT_HIERARCHY'">
        <li ng-repeat="part in \$ctrl.loanProduct.advancePaymentHierarchy" class="dragula-loans">
          {{part}}
        </li>
      </ul>

      <form-section-field field-title="'Default Strategy'"
                          ng-if="\$ctrl.loanProduct.advancePaymentStrategy === 'USER_SELECT'">
        <select
          ng-model="\$ctrl.loanProduct.userDefaultAdvancePaymentStrategy"
          ng-options="o.value as o.label for o in \$ctrl.userSelectStrategy"
          ng-required="false"></select>
      </form-section-field>

    </form-section>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/loan/details/forms/loan-product-amortization.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;